<template>
  <div>

    <b-tabs pills card active-nav-item-class="bg-info text-white font-weight-bold">

      <b-tab title="Guías de respuestas a emergencias" active @click="onHandleShowTabDetailsNuGres()">
        <ConfigNuGreComponent />
      </b-tab>

      <b-tab title="Administrar campos personalizados" @click="onHandleShowTabCustomFields()">
        <CustomFieldsComponent ref="customFieldsRef" />
      </b-tab>

    </b-tabs>

  </div>
</template>

<script>

import { mapActions } from "vuex";

// Componentes
import ConfigNuGreComponent from './configNuGre/Index.vue';
import CustomFieldsComponent from './customFields/Index.vue';

export default {
  name: "NuGreComponent",
  data() {
    return {

    };
  },
  components: {
    ConfigNuGreComponent,
    CustomFieldsComponent
  },
  methods: {
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapActions("NuGreAdmin", ['getEmergencyResponseGuides']),
    // Métodos para el modulo del Naciones unidas - gre
    ...mapActions('NuGreCustomFields', {
      getAllCustomFields: 'getAll'
    }),
    async onHandleShowTabDetailsNuGres() {
      await this.getAllCustomFields();
      await this.getEmergencyResponseGuides();
    },
    async onHandleShowTabCustomFields() {
      await this.getAllCustomFields('ALL');
    }
  }
};
</script>

<style scoped>
.bg-tab-item {
  background-color: #4e73df;
}

</style>
